module.exports = __webpack_public_path__ + "img/itx-file-type-odf.1d207a45.svg";